import HomePageForm from "components/pageSection/HomePage/HomePageForm";
import React from "react";
import { Wrapper } from "./Home.styled";

const Home = () => {
  return (
    <Wrapper>
      <HomePageForm />
    </Wrapper>
  );
};

export default Home;
